<template>
    <div
        class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50"
    >
        <div class="relative w-full max-w-[600px] bg-white rounded-[12px] px-8 pt-8 mx-4 overflow-hidden">
            <!-- 背景图层 - 从弹框顶部和左侧开始 -->
            <div
                class="absolute top-0 left-0 right-0 h-[108px] bg-no-repeat bg-cover bg-left-top"
                :style="{ backgroundImage: `url('${titleBg}')` }"
            ></div>
            <!-- 礼物盒图层 - 右上角 -->
            <div
                class="absolute right-0 top-[8px] w-[200px] h-[100px] bg-no-repeat bg-contain"
                :style="{ backgroundImage: `url('${congratulationsBg}')` }"
            ></div>
            <!-- 主要内容 -->
            <div class="relative flex flex-col items-center">
                <!-- 标题 -->
                <h2 class="text-2xl font-semibold text-[#020A1A] text-left w-full pr-[160px]">
                    {{ t('title') }}
                </h2>

                <!-- 副标题 -->
                <p class="mt-[60px] text-base leading-[1.5] text-[#495973] text-center">
                    {{ t('subtitle') }}
                </p>

                <!-- Continue 按钮 -->
                <button
                    class="th-btn th-btn-lg mt-6 w-[320px] flex items-center justify-center gap-2.5 rounded text-base font-semibold leading-[1.5] text-white transition-all"
                    @click="handleContinue"
                >
                    {{ t('continueButton') }}
                </button>

                <!-- 底部提示文字 -->
                <p class="mt-6 inline-block mb-6 text-sm leading-[1.43] text-[#8993A4] text-center">
                    {{ t('receiptSent', { email: email }) }}
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { cn, en, jp, tw } from './locales';
import congratulationsBg from './pay-sucess-congratulations.png';
import titleBg from './pay-sucess-bg.png';

interface Props {
    email: string;
    callback: () => void;
}

const props = defineProps<Props>();

const { t } = useI18n({
    messages: {
        cn,
        en,
        jp,
        tw,
    },
});

function handleContinue() {
    props.callback();
    // 刷新页面以更新用户的订阅状态
    window.location.reload();
}
</script>
